// src/components/Auth/AdminLogin.jsx
import React, { useState } from 'react';
import { Mail, Lock, ShieldCheck, Award } from 'lucide-react';
import './AdminLogin.css';

export default function AdminLogin({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');

  if (!email || !password) {
    setError('Please enter both email and password.');
    return;
  }

  try {
    const response = await fetch('https://api.lbnhyderabad.com/api/auth/admin-login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Login failed');
    }

    // Success: Notify parent component
    if (onLoginSuccess) {
      onLoginSuccess(data.admin);
    }
  } catch (err) {
    setError(err.message || 'Unable to connect to server');
  }
};


  return (
    <div className="admin-auth-viewport">
      <div className="admin-card-glass">
        {/* Brand Emblem & Headings */}
        <div className="admin-card-header">
          <div className="admin-badge-emblem">
            <ShieldCheck size={36} color="#00529b" />
          </div>
          <h1 className="admin-title-lux">Privilege Portal</h1>
          <p className="admin-subtitle-lux">Admin Management</p>
        </div>

        {/* Dynamic Error Banner */}
        {error && (
          <div className="admin-error-pill">
            <span>{error}</span>
          </div>
        )}

        {/* Input Form */}
        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="admin-input-group">
            <label>Official Email</label>
            <div className="admin-input-box">
              <Mail size={18} className="input-icon" />
              <input
                type="email"
                placeholder="admin@privilegecard.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="admin-input-group">
            <label>Password</label>
            <div className="admin-input-box">
              <Lock size={18} className="input-icon" />
              <input
                type="password"
                placeholder="••••••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <button type="submit" className="btn-gold-lux">
            Access Dashboard
          </button>
        </form>

        <div className="admin-card-footer">
          <Award size={16} />
          <span>Privilege Executive Authentication</span>
        </div>
      </div>
    </div>
  );
}